import { Component, Input, ViewChild } from '@angular/core';
import { ModalConfig } from '../modal-config';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../modal.service';
import { MultiSelect } from 'primeng/multiselect';
import { StaffService } from 'src/app/school-management/_services/staff.service';
import { Subject, takeUntil } from 'rxjs';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe.decorator';
import { GlobalService } from 'src/app/_services/global.service';
@AutoUnsubscribe
@Component({
  selector: 'app-export-staff-modal',
  templateUrl: './export-staff-modal.component.html',
  styleUrls: ['./export-staff-modal.component.scss']
})
export class ExportStaffModalComponent {
  @Input() config!: ModalConfig;
  @Input() lang: string;
  fileTypes = [];
  roles = [];
  selectedFileType = 'excel';
  selectedRoles = [];
  roleType = 'staff';
  is_paginated = 0;
  @ViewChild('multiSelectStaffExport') multiSelectStaffExport: MultiSelect;
  destroy$ = new Subject<void>(); 
  showEmptyRoleError:boolean = false;

  constructor(
    private translate: TranslateService,
    private modalService: ModalService,
    private staffService: StaffService,
    private globalService: GlobalService
  ) { }
  ngOnInit(): void {
    this.initOptions();
  }

  initOptions() {
    this.fileTypes = [
      { value: 'excel', label: this.translate.instant('staff-export-modal.file-type.excel') },
      { value: 'pdf', label: this.translate.instant('staff-export-modal.file-type.pdf') }
    ]

    this.roles = [
      { value: 'teacher', label: this.translate.instant('staff-export-modal.role-type.teachers') },
      { value: 'supervisor', label: this.translate.instant('staff-export-modal.role-type.supervisors') },
      { value: 'school_admin', label: this.translate.instant('staff-export-modal.role-type.admins') },
      { value: 'gate', label: this.translate.instant('staff-export-modal.role-type.gates') },
      { value: 'security', label: this.translate.instant('staff-export-modal.role-type.security') },
      { value: 'shared_gate_scanner', label: this.translate.instant('staff-export-modal.role-type.shared-gate') },
      { value: 'manager', label: this.translate.instant('staff-export-modal.role-type.manager') },
    ]

  }

  // generateFile() {
  //   if (this.selectedFileType == 'excel') {
  //     let body = { role_type: this.roleType, is_paginated: this.is_paginated, 
  //       filter:{
  //         role: this.selectedRoles 
  //       }
  //     };
  //     if(this.selectedRoles.length == 0 ) {
  //       this.showEmptyRoleError = true;
  //       return;
  //     }
  //     this.closeModal();
  //     this.globalService.setExportAlert('preparing');
  //     this.generatStaffExcel(body);
  //   }
  //   else if (this.selectedFileType == 'pdf') {
  //     let body = { role_type:'staff' , is_paginated:0}
  //     this.closeModal();
  //     this.globalService.setExportAlert('preparing');
  //     this.generatStaffPdf(body);
  //   }
  // }

  generateFile() {
    // Check for empty roles early and handle the error
    if (this.selectedFileType === 'excel' && this.selectedRoles.length === 0) {
      this.showEmptyRoleError = true;
      return;
    }
  
    // Close modal and show export preparation alert
    this.closeModal();
    this.globalService.setExportAlert('preparing');
  
    // Define the mapping of file types to their respective body builders and functions
    const fileTypeActions = {
      'excel': {
        bodyBuilder: () => ({
          role_type: this.roleType,
          is_paginated: this.is_paginated,
          filter: { role: this.selectedRoles }
        }),
        action: (body) => this.generateStaffExcel(body)
      },
      'pdf': {
        bodyBuilder: () => ({
          role_type: 'staff',
          is_paginated: 0
        }),
        action: (body) => this.generateStaffPdf(body)
      }
    };
  
    // Look up the fileTypeActions for the selected file type
    const selectedAction = fileTypeActions[this.selectedFileType];
  
    // If action exists for the selected type, execute it
    if (selectedAction) {
      const body = selectedAction.bodyBuilder();
      selectedAction.action(body);
    }
  }
  
  closeModal() {
    this.modalService.closeModal();
  }

  generateStaffExcel(body) {
    this.staffService.generateStaffExcel(body).pipe(takeUntil(this.destroy$)).subscribe(res => {
    })
  }

  generateStaffPdf(body) {
    this.staffService.generateStaffPdf(body).pipe(takeUntil(this.destroy$)).subscribe(res => {
    })
  }
  primeSelectChanged(event) {
    // to make the dropdown still opened 
    event?.originalEvent?.stopPropagation();
    this.multiSelectStaffExport.show();
    if(this.selectedRoles.length > 0 ){
      this.showEmptyRoleError = false;
    }
  }

  ngOnDestroy(): void {
    this.showEmptyRoleError = false;
  }
}
